import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  createProjectApiKey,
  listProjectApiKeys,
  renewProjectApiKey,
  revokeProjectApiKey,
} from "@/api/project-api-keys";

/** As chaves do projeto (#1783); a tela entrou com a #1784. */
export function useProjectApiKeys(projectId: string | undefined) {
  return useQuery({
    queryKey: ["project", projectId, "api-keys"],
    queryFn: () => listProjectApiKeys(projectId!),
    enabled: !!projectId,
  });
}

function useInvalidateKeys(projectId: string | undefined) {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ["project", projectId, "api-keys"] });
}

export function useCreateProjectApiKey(projectId: string | undefined) {
  const invalidate = useInvalidateKeys(projectId);
  return useMutation({
    mutationFn: (body: { label: string; valid_days: number }) =>
      createProjectApiKey(projectId!, body),
    onSuccess: invalidate,
  });
}

export function useRevokeProjectApiKey(projectId: string | undefined) {
  const invalidate = useInvalidateKeys(projectId);
  return useMutation({
    mutationFn: (keyId: string) => revokeProjectApiKey(projectId!, keyId),
    onSuccess: invalidate,
  });
}

export function useRenewProjectApiKey(projectId: string | undefined) {
  const invalidate = useInvalidateKeys(projectId);
  return useMutation({
    mutationFn: ({ keyId, validDays }: { keyId: string; validDays: number }) =>
      renewProjectApiKey(projectId!, keyId, validDays),
    onSuccess: invalidate,
  });
}
